<div class="margin-left-auto margin-right-auto margin-top-auto margin-bottom-auto">
  <div class="card border-all-1px nav-link-hand"
       (click)="SelectedEmbryo()">
    <div class="row">
      <div class="col-md-4">
        <label class="">AA</label>
      </div>

    </div>
    <div class="row">
      <img class="border-radius-50p nav-link-hand margin-left-auto margin-right-auto" height="35px" src="Day-5-Embryo.jpg" width="35px">
    </div>
    <div class="row">
      <div class="offset-md-8 col-md-4">
        <div class="badge badge-grading-discard  margin-bottom-3px">
          D
        </div>
      </div>
    </div>
  </div>
</div>
